<div class="clients-page">
	<div class="container container--mobile-padding" *ngIf="clientsData">
		<!-- <div class="gray-slider">
			<ngx-slick-carousel [config]="slideConfig">
				<div ngxSlickItem *ngFor="let review of reviewsData" class="slide">
					<div class="gray-slider__content">
						<p class="gray-slider__text" [innerHTML]="review.text[currentLang]"></p>
						<div class="gray-slider__author">
							<i>{{review.name[currentLang]}}</i>
							<div>{{review.from[currentLang]}}</div>
						</div>
					</div>
				</div>
			</ngx-slick-carousel>
		</div> -->

		<div class="clients-list o-hidden">
			<div class="clients-list__item animation-show" *ngFor="let client of clientsData">

				<a
					*ngIf="client.clientWorks.length; else not_clickable_card"
				    [routerLink]="['/'+currentLangUrl,'search','brand',client.slug]"
					title="{{client.name}}" class="card"
				>
					<img [src]="baseUrlImage + client.image_path" [alt]="client.name" />
				</a>

				<ng-template #not_clickable_card>
					<div class="card">
						<img [src]="baseUrlImage + client.image_path"  [alt]="client.name" />
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</div>

